import React, { useEffect, useState, useMemo } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useAuth } from "../../AuthContext";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { Checkbox } from "primereact/checkbox";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";


import "primeicons/primeicons.css";

import {
  FaList,
  FaCheck,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaDollarSign,
  FaClock,
  FaCheckCircle,
  FaTooth,
  FaBuilding,
  FaIdCard,
  FaCity,
} from "react-icons/fa";

const Servicos = () => {
  const { user } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [servicos, setServicos] = useState([]);
  const [visibleNovoServico, setVisibleNovoServico] = useState(false);
  const [visibleEditarServico, setVisibleEditarServico] = useState(false);
  const [visualizacaoResumida, setVisualizacaoResumida] = useState(false);

  //Cadastro
  const [servicoEditandoId, setServicoEditandoId] = useState(null);
  const [descricao, setDescricao] = useState("");
  const [valor, setValor] = useState("");
  const [duracao, setDuracao] = useState("");
  const [ativo, setAtivo] = useState(true);
  const [padrao, setPadrao] = useState(false);
  const [mostrarMensagemPadrao, setMostrarMensagemPadrao] = useState(false);
  const [padraoOriginal, setPadraoOriginal] = useState(false);

  // Estados para os dialogs de confirmação
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  //Filtro
  const [mostrarFiltroServicos, setMostrarFiltroServicos] = useState(false);
  const [filtroDescricao, setFiltroDescricao] = useState("");
  const [filtroValor, setFiltroValor] = useState("");

  useEffect(() => {
    fetchServicos();
  }, []);

  // Serviços filtrados e ordenados
  const servicosFiltrados = useMemo(() => {
    return servicos.filter((servico) => {
      // Filtro por descrição (se filtroDescricao não estiver vazio)
      const descricaoMatch =
        !filtroDescricao ||
        servico.descricao
          ?.toLowerCase()
          .includes(filtroDescricao.toLowerCase());

      // Filtro por valor (se filtroValor não estiver vazio)
      let valorMatch = true;
      if (filtroValor) {
        // Remove caracteres não numéricos e converte para número
        const valorBusca =
          parseFloat(filtroValor.replace(/[^\d,.]/g, "").replace(",", ".")) ||
          0;
        const valorServico = parseFloat(servico.valor) || 0;
        valorMatch = valorServico === valorBusca;
      }

      // Retorna true apenas se ambos os filtros corresponderem
      return descricaoMatch && valorMatch;
    });
  }, [servicos, filtroDescricao, filtroValor]);

  const fetchServicos = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/servicos",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        throw new Error("Erro ao buscar serviços");
      }

      const data = await response.json();

      if (data.success && Array.isArray(data.data)) {
        setServicos(data.data);
        setError(null);
      } else {
        setServicos([]);
        setError("Nenhum serviço encontrado.");
      }
    } catch (error) {
      setError(error.message);
      setServicos([]);
    } finally {
      setLoading(false);
    }
  };

  const resetarCampos = () => {
    setDescricao("");
    setValor("");
    setDuracao("");
    setAtivo(true);
    setPadrao(false);
    setMostrarMensagemPadrao(false);
  };

  const handleSalvar = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      // Verificação dos campos obrigatórios
      if (!descricao || !valor) {
        setDialogMessage("Preencha todos os campos obrigatórios");
        setShowErrorDialog(true);
        return;
      }

      const servicoData = {
        descricao: descricao,
        valor: valor,
        duracao: duracao || "",
        ativo: ativo,
        padrao: padrao,
      };

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/servicos",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(servicoData),
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Falha ao cadastrar serviço");
      }

      await response.json();
      setDialogMessage("Serviço cadastrado com sucesso!");
      setShowSuccessDialog(true);
      fetchServicos();
      setVisibleNovoServico(false);
      resetarCampos();
    } catch (err) {
      console.error("Erro detalhado ao salvar:", err);
      setDialogMessage(err.message || "Erro ao cadastrar serviço");
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const handleEditar = async (servicoId) => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      if (!descricao || !valor) {
        setDialogMessage("Preencha todos os campos obrigatórios");
        setShowErrorDialog(true);
        return;
      }

      const servicoData = {
        descricao: descricao,
        valor: valor,
        duracao: duracao || "",
        ativo: ativo,
        padrao: padrao,
      };

      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/servicos/${servicoId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(servicoData),
        },
      );

      const responseData = await response.json();

      if (!response.ok) {
        const errorMessage =
          responseData?.message ||
          responseData?.data?.message ||
          `Erro HTTP ${response.status}`;
        throw new Error(errorMessage);
      }

      setDialogMessage("Serviço atualizado com sucesso!");
      setShowSuccessDialog(true);
      fetchServicos();
      setVisibleEditarServico(false);
      resetarCampos();
    } catch (err) {
      console.error("Erro na edição:", err);
      setDialogMessage(
        err.message.includes("não encontrado")
          ? "Serviço não encontrado ou já removido"
          : err.message,
      );
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const toggleFiltroServicos = () => {
    setMostrarFiltroServicos(!mostrarFiltroServicos);
    if (mostrarFiltroServicos) {
      setFiltroDescricao("");
    }
  };

  {
    /* Return Principal */
  }
  return (
    <div
      style={{
        fontFamily: "'Rajdhani', sans-serif",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      {/* Dialog de Sucesso */}
      <Dialog
        visible={showSuccessDialog}
        style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
        onHide={() => setShowSuccessDialog(false)}
        draggable={false}
        closable={false}
        header={null}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              color: "#22C55E",
              fontSize: "2.2rem",
            }}
          >
            <i
              className="pi pi-check-circle"
              style={{ fontSize: "2.5rem" }}
            ></i>
          </div>
          <p
            style={{
              textAlign: "center",
              fontSize: "1rem",
              margin: 0,
              color: "#374151",
            }}
          >
            {dialogMessage}
          </p>
          <Button
            label="OK"
            icon="pi pi-check"
            onClick={() => setShowSuccessDialog(false)}
            className="p-button-success"
            style={{
              padding: "6px 20px",
              fontWeight: "bold",
              fontSize: "0.9rem",
            }}
          />
        </div>
      </Dialog>

      {/* Dialog de Erro */}
      <Dialog
        visible={showErrorDialog}
        style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
        onHide={() => setShowErrorDialog(false)}
        draggable={false}
        closable={false}
        header={null}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              color: "#EF4444",
              fontSize: "2.2rem",
            }}
          >
            <i
              className="pi pi-times-circle"
              style={{ fontSize: "2.5rem" }}
            ></i>
          </div>
          <p
            style={{
              textAlign: "center",
              fontSize: "1rem",
              margin: 0,
              color: "#374151",
            }}
          >
            {dialogMessage}
          </p>
          <Button
            label="OK"
            onClick={() => setShowErrorDialog(false)}
            className="p-button-danger"
            style={{
              padding: "6px 20px",
              fontWeight: "bold",
              fontSize: "0.9rem",
            }}
          />
        </div>
      </Dialog>

      {/* Dialog Novo */}
      <Dialog
        visible={visibleNovoServico}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleNovoServico(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-45px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaList style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  ADICIONAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  SERVIÇO
                </div>
              </div>
            </div>
          </div>
        }
      >
        <>
          {/* Formulário em Cards */}
          <div style={{ padding: "20px 0" }}>
            {/* 1ª Linha - Descrição e CNPJ */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              {/* Card Descrição */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #3498DB",
                    }}
                  >
                    <FaList style={{ color: "#3498DB", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Descrição *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="Descrição do serviço"
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 2ª Linha - Email e Telefone */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              {/* Card Valor */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E67E22",
                    }}
                  >
                    <FaDollarSign
                      style={{ color: "#E67E22", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Valor *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="R$ 0,00"
                    value={valor}
                    onChange={(e) => setValor(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card Tempo */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E74C3C",
                    }}
                  >
                    <FaClock style={{ color: "#E74C3C", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Duração (min) *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="Minutos"
                    value={duracao}
                    onChange={(e) => setDuracao(e.target.value)}
                    type="number"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card Ativo */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaCheckCircle
                      style={{ color: "#2980B9", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Ativo *
                    </span>
                  </div>
                  <Checkbox
                    checked={ativo}
                    onChange={(e) => setAtivo(e.checked)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Botão Fechar */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              onClick={() => {
                resetarCampos();
                setVisibleNovoServico(false);
              }}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "120px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading}
            />
            <Button
              label={loading ? "SALVANDO..." : "CADASTRAR SERVIÇO"}
              icon="pi pi-check"
              onClick={handleSalvar}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "160px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading || !descricao || !valor || !duracao}
              loading={loading}
            />
          </div>
        </>
      </Dialog>

      {/* Dialog Editar */}
      <Dialog
        visible={visibleEditarServico}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleEditarServico(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-45px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaList style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  EDITAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  SERVIÇO
                </div>
              </div>
            </div>
          </div>
        }
      >
        <>
          {/* Formulário em Cards */}
          <div style={{ padding: "20px 0" }}>
            {/* 1ª Linha - Descrição e CNPJ */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              {/* Card Descrição */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #3498DB",
                    }}
                  >
                    <FaList style={{ color: "#3498DB", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Descrição *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="Descrição do serviço"
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 2ª Linha - Email e Telefone */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              {/* Card Valor */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E67E22",
                    }}
                  >
                    <FaDollarSign
                      style={{ color: "#E67E22", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Valor *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="R$ 0,00"
                    value={valor}
                    onChange={(e) => setValor(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card Tempo */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E74C3C",
                    }}
                  >
                    <FaClock style={{ color: "#E74C3C", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Duração (min) *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="Minutos"
                    value={duracao}
                    onChange={(e) => setDuracao(e.target.value)}
                    type="number"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card Ativo */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaCheckCircle
                      style={{ color: "#2980B9", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Ativo *
                    </span>
                  </div>
                  <Checkbox
                    checked={ativo}
                    onChange={(e) => setAtivo(e.checked)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>

              {/* Card Padrão */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaCheck style={{ color: "#2980B9", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Padrão *
                    </span>
                  </div>
                  <Checkbox
                    checked={padrao}
                    onChange={(e) => {
                      const novoValor = e.checked;
                      setPadrao(novoValor);
                      setMostrarMensagemPadrao(!padraoOriginal && novoValor);
                    }}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                    }}
                  />
                </div>
              </div>
            </div>

            {padraoOriginal && (
              <div
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  padding: "10px",
                  marginTop: "10px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ paddingLeft: "36px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <i
                      className="pi pi-info-circle"
                      style={{ fontSize: "0.8rem", color: "#f1c40f" }}
                    ></i>
                    <span style={{ fontSize: "0.85rem", color: "#5e6f7d" }}>
                      Este serviço é o PADRÃO. Se desmarcar, outro precisará ser
                      definido.
                    </span>
                  </div>
                </div>
              </div>
            )}

            {mostrarMensagemPadrao && !padraoOriginal && padrao && (
              <div
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  padding: "10px",
                  marginTop: "10px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ paddingLeft: "36px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <i
                      className="pi pi-info-circle"
                      style={{ fontSize: "0.8rem", color: "#3498db" }}
                    ></i>
                    <span style={{ fontSize: "0.85rem", color: "#5e6f7d" }}>
                      Ao marcar esta opção para tornar este serviço o PADRÃO.
                    </span>
                    <span style={{ fontSize: "0.85rem", color: "#5e6f7d" }}>
                      Ao salvar, ele substituirá o serviço padrão atual.
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Botão Fechar */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              onClick={() => {
                resetarCampos();
                setVisibleEditarServico(false);
              }}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "120px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading}
            />
            <Button
              label={loading ? "SALVANDO..." : "SALVAR ALTERAÇÕES"}
              icon="pi pi-check"
              onClick={() => handleEditar(servicoEditandoId)}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "160px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading || !descricao || !valor || !duracao}
              loading={loading}
            />
          </div>
        </>
      </Dialog>

      {/* Barra superior vermelha */}
      <div
        style={{
          backgroundColor: "#B83732",
          height: "40px",
          minHeight: "40px",
          width: "100%",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          fontWeight: "bold",
          position: "fixed",
          zIndex: 1,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        {/* lado esquerdo */}
        <div></div>

        {/* Centro */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            icon="pi pi-refresh"
            className="icon-button-titulo"
            onClick={() => {
              fetchServicos();
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon={visualizacaoResumida ? "pi pi-eye" : "pi pi-eye-slash"}
            className="icon-button-titulo"
            onClick={() => {
              setVisualizacaoResumida(!visualizacaoResumida);
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon={mostrarFiltroServicos ? "pi pi-filter-slash" : "pi pi-filter"}
            className="icon-button-titulo"
            onClick={() => {
              setMostrarFiltroServicos(!mostrarFiltroServicos);
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon="pi pi-plus"
            className="icon-button-titulo"
            onClick={() => {
              if (
                user.tipo === "administrator" ||
                user.modulos?.Servicos?.editar
              ) {
                setVisibleNovoServico(true);
                resetarCampos();
                setMostrarMensagemPadrao(false); // RESETA AO ABRIR
              }
            }}
            disabled={
              !(user.tipo === "administrator" || user.modulos?.Servicos?.editar)
            }
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              opacity:
                user.tipo === "administrator" || user.modulos?.Servicos?.editar
                  ? 1
                  : 0.4,
              cursor:
                user.tipo === "administrator" || user.modulos?.Servicos?.editar
                  ? "pointer"
                  : "not-allowed",
            }}
            outlined
          />
        </div>

        {/* lado direito */}
        <div></div>
      </div>

      {/* Conteúdo abaixo da barra */}
            <div style={{ flex: 1, padding: "50px 10px" }}>
              {/* MOSTRAR RESERVAS DO DIA SELECIONADO - SEMPRE VISÍVEL */}
              <div style={{ borderRadius: "8px", padding: "0 15px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #E2E8F0",
                  }}
                >
                  <div style={{ marginTop: "7px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "8px",
                        gap: "5px",
                      }}
                    >
                      <FaList style={{ color: "#B83732", fontSize: "1.2rem" }} />
                      <h3 style={{ margin: 0, color: "#424242" }}>SERVIÇOS</h3>
      
                      {/* Bolinha com quantidade */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          minWidth: "25px",
                          height: "25px",
                          background:
                            "linear-gradient(135deg, #B83732 0%, #D65A55 100%)",
                          borderRadius: "50px",
                          padding: "0 8px",
                          margin: "0 8px",
                          boxShadow: "0 2px 4px rgba(184, 55, 50, 0.2)",
                        }}
                      >
                        <span
                          style={{
                            color: "white",
                            fontSize: "0.85rem",
                            fontWeight: "600",
                            lineHeight: 1,
                          }}
                        >
                          {servicos.length}
                        </span>
                      </div>
                    </div>
                  </div>
      
                  <div>
                    <IconField iconPosition="left">
                      <InputIcon className="pi pi-search"> </InputIcon>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Pesquisar por Nome"
                        value={filtroDescricao}
                        onChange={(e) => setFiltroDescricao(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "30px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </IconField>
                  </div>
                </div>

          {/* InputSwitch */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              marginBottom: "30px",
            }}
          ></div>

          {/* Filtros para Empresa */}
          {mostrarFiltroServicos && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  borderRadius: "8px",
                  padding: "10px 8px",
                  border: "1px solid #dee2e6",
                  backgroundColor: "#fff",
                  width: "95%",
                  maxWidth: "520px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                {/* 1ª Linha - Nome e CPF */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(200px, 1fr))",
                    gap: "10px",
                  }}
                >
                  {/* Card Descrição */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #3498DB",
                        }}
                      >
                        <FaList
                          style={{ color: "#3498DB", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Descrição{" "}
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Descrição do serviço"
                        value={filtroDescricao}
                        onChange={(e) => setFiltroDescricao(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  {/* Card CNPJ */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #E67E22",
                        }}
                      >
                        <FaDollarSign
                          style={{ color: "#E67E22", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Valor{" "}
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Valor do serviço"
                        value={filtroValor}
                        onChange={(e) => setFiltroValor(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Grids */}
<div
  style={{
    display: "flex",
    flexDirection: "column",
    padding: "10px 8px",
  }}
>
  {servicosFiltrados.length === 0 ? (
    <div
      style={{
        textAlign: "center",
        padding: "40px 20px",
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
        border: "2px dashed #e8e8e8",
      }}
    >
      <FaList
        style={{
          fontSize: "3rem",
          color: "#B83732",
          marginBottom: "15px",
          opacity: 0.5,
        }}
      />
      <h3
        style={{
          color: "#2c3e50",
          margin: "0 0 10px 0",
          fontSize: "1.2rem",
          fontWeight: "600",
        }}
      >
        Nenhum serviço encontrado
      </h3>
    </div>
  ) : !visualizacaoResumida ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      {servicosFiltrados.map((item, idx) => (
        <div key={idx}>
          <div
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #e8e8e8",
              borderRadius: "10px",
              padding: "12px 14px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "12px",
              flexWrap: "wrap",
            }}
          >
            {/* Bloco esquerdo - Serviço */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                minWidth: "260px",
                flex: "1 1 260px",
              }}
            >
              <FaList
                style={{
                  fontSize: "2.5rem",
                  color: "#D65A55",
                  flexShrink: 0,
                }}
              />
              <div style={{ minWidth: 0 }}>
                <h3
                  style={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "#2c3e50",
                    margin: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.descricao}
                </h3>

                {/* Info Tags */}
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "5px",
                    alignItems: "center",
                    color: "#64748b",
                    fontSize: "0.9rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      marginRight: "6px",
                    }}
                  >
                    <FaClock style={{ fontSize: "0.7rem", color: "#2980b9" }} />
                    <span>{item.duracao} min</span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      marginRight: "6px",
                    }}
                  >
                    <FaDollarSign style={{ fontSize: "0.7rem", color: "#d35400" }} />
                    <span>R$ {item.valor}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Status + Ações */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "8px",
                flex: "1 1 320px",
                marginLeft: "auto",
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "2px 6px",
                  borderRadius: "12px",
                  fontSize: "0.75rem",
                  fontWeight: "500",
                  color: item.ativo === "1" ? "#27ae60" : "#e74c3c",
                }}
              >
                <div
                  style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: item.ativo === "1" ? "#27ae60" : "#e74c3c",
                  }}
                />
              </div>

              {/* Padrão */}
              {item.padrao === "1" && (
                <Button
                  icon="pi pi-star"
                  className="p-button-outlined p-button-sm"
                  style={{
                    outline: "none",
                    boxShadow: "none",
                    width: "25px",
                    height: "25px",
                    borderColor: "#f1c40f",
                    color: "#f1c40f",
                    backgroundColor: "#fff9e6",
                  }}
                  tooltip="Serviço Padrão"
                  tooltipOptions={{ position: "top" }}
                />
              )}

              {/* Botões de ação */}
              <Button
                icon="pi pi-file-edit"
                onClick={() => {
                  if (
                    user.tipo === "administrator" ||
                    user.modulos?.Servicos?.editar
                  ) {
                    const ehPadrao = item.padrao === "1";

                    setServicoEditandoId(item.id);
                    setDescricao(item.descricao || "");
                    setValor(item.valor || "");
                    setDuracao(item.duracao || "");
                    setAtivo(item.ativo === "1");
                    setPadrao(ehPadrao);
                    setPadraoOriginal(ehPadrao);
                    setMostrarMensagemPadrao(false);

                    setVisibleEditarServico(true);
                  }
                }}
                disabled={
                  !(
                    user.tipo === "administrator" ||
                    user.modulos?.Servicos?.editar
                  )
                }
                className="p-button-outlined p-button-sm"
                style={{
                  outline: "none",
                  boxShadow: "none",
                  width: "25px",
                  height: "25px",
                  borderColor: "#dee2e6",
                  color: "#495057",
                  opacity:
                    user.tipo === "administrator" ||
                    user.modulos?.Servicos?.editar
                      ? 1
                      : 0.4,
                  cursor:
                    user.tipo === "administrator" ||
                    user.modulos?.Servicos?.editar
                      ? "pointer"
                      : "not-allowed",
                }}
                tooltip="Editar"
                tooltipOptions={{ position: "top" }}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  ) : (
    <div
      className="grid"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
        gap: "15px",
        alignItems: "stretch",
      }}
    >
      {servicosFiltrados.map((item, idx) => (
        <div key={idx}>
          <div
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #e8e8e8",
              borderRadius: "10px",
              padding: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              transition: "all 0.3s ease",
              "&:hover": {
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                transform: "translateY(-2px)",
              },
            }}
          >
            {/* Informações */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                marginBottom: "5px",
                paddingBottom: "5px",
                borderBottom: "1px solid #e8e8e8",
              }}
            >
              <FaList
                style={{
                  fontSize: "2.5rem",
                  color: "#D65A55",
                  flexShrink: 0,
                }}
              />
              <div style={{ flex: 1, minWidth: 0 }}>
                <h3
                  style={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "#2c3e50",
                    margin: "0",
                    padding: "1px",
                    lineHeight: "1.1",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    height: "2.2em",
                    wordBreak: "break-word",
                  }}
                >
                  {item.descricao}
                </h3>
              </div>
            </div>

            {/* Detalhes */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "6px",
                marginBottom: "5px",
              }}
            >
              {/* Coluna 1 */}
              <div
                style={{
                  display: "flex",
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #e8e8e8",
                  padding: "6px",
                  borderRadius: "6px",
                  flexDirection: "column",
                  gap: "5px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <FaClock
                    style={{ color: "#2980b9", fontSize: "0.75rem" }}
                  />
                  <span
                    style={{
                      fontSize: "0.8rem",
                      color: "#2c3e50",
                      fontWeight: "500",
                    }}
                  >
                    {item.duracao} min
                  </span>
                </div>
              </div>

              {/* Coluna 2 */}
              <div
                style={{
                  display: "flex",
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #e8e8e8",
                  padding: "6px",
                  borderRadius: "6px",
                  flexDirection: "column",
                  gap: "5px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <FaDollarSign
                    style={{ color: "#d35400", fontSize: "0.75rem" }}
                  />
                  <span
                    style={{
                      fontSize: "0.8rem",
                      color: "#2c3e50",
                      fontWeight: "500",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    R$ {item.valor}
                  </span>
                </div>
              </div>
            </div>

            {/* Ações Secundárias */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: "5px",
                gap: "5px",
                marginTop: "auto",
                borderTop: "1px solid #e8e8e8",
              }}
            >
              {/* Ativo */}
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                }}
              >
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    fontFamily: "'Rajdhani', sans-serif",
                    gap: "6px",
                    padding: "2px 6px",
                    borderRadius: "12px",
                    fontSize: "0.75rem",
                    fontWeight: "500",
                    color: item.ativo === "1" ? "#27ae60" : "#e74c3c",
                  }}
                >
                  <div
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: item.ativo === "1" ? "#27ae60" : "#e74c3c",
                    }}
                  />
                </div>
              </div>

              {/* Botoes */}
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                }}
              >
                {/* Padrão */}
                {item.padrao === "1" && (
                  <Button
                    icon="pi pi-star"
                    className="p-button-outlined p-button-sm"
                    style={{
                      outline: "none",
                      boxShadow: "none",
                      width: "25px",
                      height: "25px",
                      borderColor: "#f1c40f",
                      color: "#f1c40f",
                      backgroundColor: "#fff9e6",
                    }}
                    tooltip="Serviço Padrão"
                    tooltipOptions={{ position: "top" }}
                  />
                )}

                <Button
                  icon="pi pi-file-edit"
                  onClick={() => {
                    if (
                      user.tipo === "administrator" ||
                      user.modulos?.Servicos?.editar
                    ) {
                      const ehPadrao = item.padrao === "1";

                      setServicoEditandoId(item.id);
                      setDescricao(item.descricao || "");
                      setValor(item.valor || "");
                      setDuracao(item.duracao || "");
                      setAtivo(item.ativo === "1");
                      setPadrao(ehPadrao);
                      setPadraoOriginal(ehPadrao);
                      setMostrarMensagemPadrao(false);

                      setVisibleEditarServico(true);
                    }
                  }}
                  disabled={
                    !(
                      user.tipo === "administrator" ||
                      user.modulos?.Servicos?.editar
                    )
                  }
                  className="p-button-outlined p-button-sm"
                  style={{
                    outline: "none",
                    boxShadow: "none",
                    width: "25px",
                    height: "25px",
                    borderColor: "#dee2e6",
                    color: "#495057",
                  }}
                  tooltip="Editar"
                  tooltipOptions={{ position: "top" }}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )}
</div>
        </div>
      </div>

      {/* Loading Spinner */}
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
          }}
        >
          <ProgressSpinner
            style={{ width: "50px", height: "50px" }}
            strokeWidth="8"
          />
        </div>
      )}
    </div>
  );
};

export default Servicos;
